export default {"src":"/_next/static/media/copy-green.32dbd939.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};